import { ManualIncidentCategoriesQuery } from '@/graphql/generated/operations'
import { getIncidentCategoryOptions } from '@/utils/forms/optionBuilders'
import { sortOptions } from '@/utils/forms/optionHelpers'
import { STRING_REGEX } from '@/utils/forms/validation'

export const isDeviceHealthSelected = (
  incidentCategoriesData: ManualIncidentCategoriesQuery,
  incidentCategoryId: string
): boolean => {
  const incidentCategories = sortOptions(
    getIncidentCategoryOptions(incidentCategoriesData)
  )
  return (
    incidentCategories?.find((i) => i.value === incidentCategoryId)?.label ===
    'Device Health'
  )
}

export const nameRules = {
  maxLength: {
    value: 255,
    message: 'Incident name should have less than 256 characters',
  },
  pattern: {
    value: STRING_REGEX,
    message: 'Insert only alphanumeric characters and spaces',
  },
}

export const descriptionRules = {
  maxLength: {
    value: 1_000,
    message: `Incident description can't have more than 1,000 characters`,
  },
  pattern: {
    value: STRING_REGEX,
    message: 'Insert only alphanumeric characters and spaces',
  },
}

export const facilityNameRules = {
  required: 'Facility name is required',
}

export const floorNameRules = {
  required: 'Floor name is required',
}

export const incidentCategoryRules = {
  required: 'Incident category is required',
}
